const Abort = () => (
  <section className="hero is-halfheight">
    <div className="hero-body">
      <div className="mx-auto is-size-3 has-text-grey">
        Report generation cancelled
      </div>
    </div>
  </section>
);

export default Abort;
